<template>
    <fragment>
        <button 
            @click="openShareCb"
            class="share-button"
            :class="{ [`share-button--${color}`]: true }">
            <svg :class="classes" width="45px" height="45px" viewBox="0 0 46 46" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                <g id="Final" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                    <g id="Get-Styled---Item-Liked" transform="translate(-13.000000, -742.000000)">
                        <g id="Group-16" transform="translate(13.000000, 742.000000)">
                            <circle id="Oval" stroke="#000000" cx="23" cy="23" r="22.5"></circle>
                            <path d="M25.8671398,15.0053427 C25.9985554,15.0232497 26.1220165,15.0774304 26.2230278,15.1615237 L33.1957569,20.840831 C33.353415,20.9703353 33.4444444,21.1613296 33.4444444,21.3626174 C33.4444444,21.5639053 33.353415,21.7548996 33.1957569,21.8844038 L26.2230278,27.5636953 C26.0158462,27.7302842 25.7292591,27.7659341 25.4859897,27.6553788 C25.2427203,27.5448236 25.0859097,27.3076689 25.0827078,27.0454698 L25.0827078,24.7808574 C23.5105666,24.7953964 18.1032619,25.0878353 14.1515143,28.4652967 C13.9149038,28.663742 13.5722712,28.6845624 13.3123344,28.5162904 C13.0523976,28.3480183 12.9383261,28.031547 13.0329492,27.741185 C14.9855689,21.8612208 20.8544218,19.2583579 25.0827078,18.1289618 L25.0827078,15.6868596 C25.0811529,15.4903407 25.1664601,15.3027299 25.3167403,15.172166 C25.4670206,15.0416021 25.6676465,14.9807934 25.8671398,15.0053427 L25.8671398,15.0053427 Z M26.4772535,17.135083 L26.4772535,18.6400994 C26.4773892,18.9509897 26.2622702,19.2225731 25.9542989,19.3003189 C22.5377315,20.1456975 17.9068169,22.0384175 15.4661526,25.8882996 C20.1358588,23.2067578 25.3732846,23.3903812 25.8162853,23.4107131 C26.1871157,23.4296445 26.4777219,23.7292853 26.4772535,24.09223 L26.4772535,25.5901587 L31.6704955,21.366167 L26.4772535,17.135083 Z" id="Shape-Copy" fill="#000000" fill-rule="nonzero"></path>
                        </g>
                    </g>
                </g>
            </svg>
        </button>
    </fragment>
</template>

<script>
    import { Fragment } from 'vue-fragment';

    export default {
        props: {
            openShareCb: Function,
            classes: String|Array|Object,
            color: String,
        },
        components: {
            Fragment,
        },
    }
</script>

<style lang="scss" scoped>
    .share-button {
      margin: 0 5px;
      width: 45px;
      height: 45px;
      &--white {
          circle {
              stroke: white;
          }
          path {
              fill: white;
          }
      }
    }
</style>